/*
  BLUE QUILL ANGLER — FLY TYING VIDEO LIBRARY
  ------------------------------------------------------------
  VIDEO LIBRARY + MATERIALS VERSION

  FEATURES
  - Custom thumbnail or YouTube thumbnail fallback
  - Clickable thumbnail
  - Watch Video button
  - Optional Shop Materials button
  - Materials modal generated from this JS file
  - Fly type/category tag
  - Topic filtering
  - Approx. 180-character description preview
  - More / Less description expansion
  - Search, category, topic and sorting
  - Click-to-load YouTube video modal
  - YouTube Privacy Enhanced Mode
  - No autoplay

  ------------------------------------------------------------
  HOW TO ADD MATERIALS

  Add items inside the materials array for each fly:

  materials: [
    {
      type: 'Hook',
      name: 'Tiemco 101',
      detail: 'Size 20',
      url: '/products/tiemco-101'
    },
    {
      type: 'Thread',
      name: 'UNI 8/0',
      detail: 'Gray',
      url: '/products/uni-thread-8-0'
    }
  ],

  If materials: [] is empty, the Shop Materials
  button will NOT appear.
*/

(function () {
  'use strict';

  /* ==========================================================
     VIDEO DATA
     ========================================================== */

  var VIDEOS = [

    /* ========================================================
       1. MERCURY FLASHBACK RS2
       ======================================================== */

    {
      id: 'mercury-flashback-rs2',

      title: 'Mercury Flashback RS2',

      youtube:
        'https://youtu.be/HNX7p2MQkx0',

      thumbnailUrl:
        'https://cdn.shopify.com/s/files/1/0677/3804/2646/files/Merc_RS2.png?v=1787868724',

      duration: '5:12',

      category: 'Nymph',

      topics: [
        'Midges',
        'Glass Beads',
        'Emergers',
        'Dubbing',
        'Flash',
        'Hackle'
      ],

      instructor: 'Pat Dorsey',

      description:
        'The Flashback RS2 was invented by Roaring Fork and South Platte River guide Tom Whitley. His design incorporated a split micro-fibet tail, Adams Gray Super Fine dubbing for the abdomen, pearl Mylar tinsel for the back strap, and white ostrich herl for the wing. I tweaked his pattern and came up with my own variation—the Mercury Flashback RS2. My pattern uses dark dun hackle fibers for the tail, gray Super Fine Dubbing for a thin and sparse abdomen, Glamour Madeira for the wing, and a small silver-lined glass bead to enhance the gas-bubble effect that occurs during the emerging process.',

      materials: [
        
        {
          type: 'Hook',
          name: 'Tiemco 101',
          detail: 'Size 18–24',
          url: 'https://bluequillangler.com/products/tiemco-101-25-pack-1?_pos=1&_sid=cd3e18e74&_ss=r',
        },
        {
          type: 'Thread',
          name: '8/0 Uni-Thread',
          detail: 'Gray',
          url: 'https://bluequillangler.com/collections/fly-tying-thread-floss/products/uni-8-0-thread-1',
        },
        {
          type: 'Tail',
          name: 'Saddle Hackle Fibers',
          detail: 'Gray',
          url: 'https://bluequillangler.com/collections/fly-tying-hackle/products/whiting-hen-saddle?variant=47494876299542',
        },
        {
          type: 'Flashback',
          name: 'Pearl Mylar Tinsel',
          detail: 'Small',
          url: 'https://bluequillangler.com/collections/fly-tying-tinsel/products/pearl-tinsel-flat?variant=43892939915542',
        },
        {
          type: 'Abdomen',
          name: 'Superfine Dubbing',
          detail: 'Gray',
          url: 'https://bluequillangler.com/collections/fly-tying-dubbing/products/superfine-dubbing',
        },
        {
          type: 'Wing',
          name: 'Glamour Madeira (Top Secret Wing Material)',
          detail: '',
          url: 'https://bluequillangler.com/products/top-secret-midge-wing-material?_pos=3&_sid=69315195d&_ss=r',
        },
        {
          type: 'Thorax',
          name: 'Superfine Dubbing',
          detail: 'Gray',
          url: 'https://bluequillangler.com/collections/fly-tying-dubbing/products/superfine-dubbing',
        }
      ],

      publishedDate: '',

      order: 1,

      published: true
    },


    /* ========================================================
       2. PAT'S MIDGE
       ======================================================== */

    {
      id: 'pats-midge',

      title: 'Pats Midge',

      youtube:
        'https://youtu.be/_w8xK4lwayk?si=UyJD0k-o8JjGZNsp',

      thumbnailUrl:
        'https://cdn.shopify.com/s/files/1/0677/3804/2646/files/Pat_s_Midge.png?v=1787806982',

      duration: '5:09',

      category: 'Nymph',

      topics: [
        'Midges',
        'Hackle',
        'Wing',
        'Peacock'
      ],

      instructor: 'Pat Dorsey',

      description:
        'Pat’s Midge is Dorsey’s new trailing shuck midge dry fly pattern. This pattern is extremely useful in sizes 18-24, covering midge hatches year around! On technical tailwaters, this is a fantastic option to fool weary trout. Yet, this pattern also thrives on freestones and smaller creeks. Midges are a vital part of a trout’s diet, and a great midge dry is absolutely necessary for the dry fly angler. The white Z-Lon loop wing, along with the trailing shuck, peacock herl thorax, and grizzly hackle make this pattern a dead on match for the body profile of the naturals, while floating just right to entice the fish below. The white wing on this pattern gives the angler an edge in terms of seeing the fly on the surface without sacrificing the profile of the fly, or using a fly too big for the situation.',

      materials: [
        {
          type: 'Hook',
          name: 'Tiemco 101',
          detail: 'Size 16–24',
          url: 'https://bluequillangler.com/products/tiemco-101-25-pack-1?_pos=1&_sid=cd3e18e74&_ss=r',
        },
        {
          type: 'Thread',
          name: '8/0 Uni-Thread',
          detail: 'Black',
          url: 'https://bluequillangler.com/collections/fly-tying-thread-floss/products/uni-8-0-thread-1',
        },
        {
          type: 'Tail',
          name: 'Z-lon',
          detail: 'Rust',
          url: 'https://bluequillangler.com/products/betts-standard-z-lon?_pos=2&_sid=a7bcb2187&_ss=r',
        },
        {
          type: 'Wing',
          name: 'Z-lon',
          detail: 'White',
          url: 'https://bluequillangler.com/products/betts-standard-z-lon?_pos=2&_sid=a7bcb2187&_ss=r',
        },
        {
          type: 'Thorax',
          name: 'Peacock Hurl',
          detail: '',
          url: 'https://bluequillangler.com/collections/fly-tying-feathers/products/fulling-mill-premium-selected-peacock-herl',
        },
        {
          type: 'Hackle',
          name: 'Grizzly Rooster',
          detail: '',
          url: 'https://bluequillangler.com/products/whiting-bronze-rooster-cape?_pos=2&_sid=80a3f8304&_ss=r&variant=51022875197718',
        },
        {
          type: 'Antennae',
          name: 'Z-long',
          detail: 'White',
          url: 'https://bluequillangler.com/products/betts-standard-z-lon?_pos=2&_sid=a7bcb2187&_ss=r',
        }
      ],

      publishedDate: '',

      order: 2,

      published: true
    },


    /* ========================================================
       3. TOP SECRET MIDGE
       ======================================================== */

    {
      id: 'top-secret-midge',

      title: 'Top Secret Midge',

      youtube:
        'https://youtu.be/B6vAB-2caiw?si=iiydigP7UJxW76V8',

      thumbnailUrl:
        'https://cdn.shopify.com/s/files/1/0677/3804/2646/files/Top_Secret_Midge_2.png?v=1787806982',

      duration: '4:45',

      category: 'Nymph',

      topics: [
        'Dubbing',
        'Midge',
        'Ribbing'
      ],

      instructor: 'Pat Dorsey',

      description:
        'The Top Secret Midge was invented during the winter of 2001. It was designed to imitate the millions of midges that hatch on a daily basis along South Platte watershed. The Top Secret Midge has an interesting history—it was given its name while a group of guides were enjoying a nice day of fly-fishing (a day off) below the small community of Deckers. I had hooked a fair number of nice brown trout in a run several hundred yards above the Trumbull bridge when Mick Stefan—one of my fishing companions—asked me what pattern I was catching my fish on??',

      materials: [ {
          type: 'Hook',
          name: 'Tiemco 2488',
          detail: 'Size 18-26',
          url: 'https://bluequillangler.com/products/tiemco-2488-25-pack?_pos=1&_sid=9f0c28377&_ss=r',
        },
        {
          type: 'Thread',
          name: '8/0 Uni-Thread',
          detail: 'Dark Brown',
          url: 'https://bluequillangler.com/collections/fly-tying-thread-floss/products/uni-8-0-thread-1',
        },
        {
          type: 'Rib',
          name: '6/0 Uni-Thread',
          detail: 'Rust',
          url: 'https://bluequillangler.com/collections/fly-tying-thread-floss/products/uni-6-0-thread',
        },
        {
          type: 'Wing',
          name: 'Glamour Madeira (Top Secret Wing Material)',
          detail: '',
          url: 'https://bluequillangler.com/products/top-secret-midge-wing-material?_pos=3&_sid=69315195d&_ss=r',
        },
        
        {
          type: 'Thorax',
          name: 'Dubbing',
          detail: 'Rust Brown',
          url: 'https://bluequillangler.com/collections/fly-tying-dubbing/products/superfine-dubbing',
        }
      ],

      publishedDate: '',

      order: 3,

      published: true
    },


    /* ========================================================
       4. MERCURY FLASHBACK PHEASANT TAIL NYMPH
       ======================================================== */

    {
      id: 'pheasant-tail-nymph',

      title:
        'Mercury Flashback Pheasant Tail Nymph',

      youtube:
        'https://youtu.be/xi_xqr9inrI',

      thumbnailUrl:
        'https://cdn.shopify.com/s/files/1/0677/3804/2646/files/Mercury_PT.png?v=1787806982',

      duration: '5:56',

      category: 'Nymph',

      topics: [
        'Pheasant Tail',
        'Wire',
        'Wing Cases',
        'Rib'
      ],

      instructor: 'Pat Dorsey',

      description:
        "Build one of fly fishing's most dependable mayfly nymph imitations while focusing on pheasant tail fibers, ribbing, proportions and a clean thorax.",

      materials: [
        {
          type: 'Hook',
          name: 'Tiemco 101',
          detail: 'Size 16-22',
          url: 'https://bluequillangler.com/products/tiemco-101-25-pack-1?_pos=1&_sid=75a026558&_ss=r',
        },
        {
          type: 'Bead',
          name: 'Glass Bead',
          detail: 'Extra Small',
          url: 'https://bluequillangler.com/collections/fly-tying-beads/products/glass-beads-x-small-1?variant=43892898791702',
        },
        {
          type: 'Thread',
          name: '8/0 Uni-Thread',
          detail: 'Black',
          url: 'https://bluequillangler.com/collections/fly-tying-thread-floss/products/uni-8-0-thread-1',
        },
            {
          type: 'Tail/Thorax/Legs',
          name: 'Pheasant Tail Fibers',
          detail: 'Natural',
          url: '',
        },
        {
          type: 'Rib',
          name: 'Gold Ultra Wire',
          detail: 'Extra Small',
          url: 'https://bluequillangler.com/collections/fly-tying-wire/products/utc-ultra-wire',
        },        
        {
          type: 'Thorax',
          name: 'Peacock Herl',
          detail: '',
          url: 'https://bluequillangler.com/products/fulling-mill-premium-selected-peacock-herl?_pos=1&_sid=2964b450d&_ss=r',
        }],

      publishedDate: '',

      order: 4,

      published: true
    },


    /* ========================================================
       5. HI VIZ GRIFFITH GNAT
       ======================================================== */

    {
      id: 'Griffith Gnat',

      title: 'Hi Viz Grifith Gnat',

      youtube:
        'https://youtu.be/5o_kfUZ6MeI',

      thumbnailUrl:
        'https://cdn.shopify.com/s/files/1/0677/3804/2646/files/Hi_Viz_Griffith.png?v=1787806983',

      duration: '4:22',

      category: 'Nymph',

      topics: [
        'Dubbing',
        'Ribbing',
        'Natural Materials',
        'Hackle',
        'Peacock'
      ],

      instructor: 'Pat Dorsey',

      description:
        'Pat Dorsey ties the super effective Hi-Vis Griffith Gnat which is perfect for Spring midge fishing.  The larger sizes (#14-16) are the perfect midge cluster as well as a top fly in a dry/dropper rig and the smaller (#18-20) represent single midges.',

      materials: [
        {
          type: 'Hook',
          name: 'Tiemco 101',
          detail: 'Size 14-20',
          url: 'https://bluequillangler.com/products/tiemco-101-25-pack-1?_pos=1&_sid=75a026558&_ss=r',
        },
        {
          type: 'Body',
          name: 'Peacock Eye Strands',
          detail: '',
          url: 'https://bluequillangler.com/products/fulling-mill-premium-selected-peacock-herl',
        },
        {
          type: 'Wing',
          name: 'Darlon/McFlylon',
          detail: 'FL Cerise',
          url: 'https://bluequillangler.com/products/mcflylon?_pos=1&_sid=647db6513&_ss=r',
        },
            {
          type: 'Hackle',
          name: 'Grizzly Rooster',
          detail: '',
          url: 'https://bluequillangler.com/products/whiting-bronze-rooster-cape?_pos=2&_sid=9293c439d&_ss=r&variant=51022875197718',
        }
      ],

      publishedDate: '',

      order: 5,

      published: true
    },


    /* ========================================================
       6. MERCURY BLACK BEAUTY
       ======================================================== */

    {
      id: 'mercury-black-beauty',

      title: 'Mercury Black Beauty',

      youtube:
        'https://youtu.be/F20BojRR4uk',

      thumbnailUrl:
        'https://cdn.shopify.com/s/files/1/0677/3804/2646/files/Mercury_Black_Beauty.png?v=1787867884',

      duration: '4:36',

      category: 'Nymph',

      topics: [
        'Glass Bead',
        'Ribbing',
        'Dubbing'
      ],

      instructor: 'Pat Dorsey',

      description:
        'The perfect winter midge. The mercury glass bead simulates the gas bubble that the emerging midge uses to rise to the surface. The original Black Beauty was invented in the early 1990’s to imitate the heavy concentrations of midge pupae found in tailraces below deep, bottom-release reservoirs. Don’t let the simplicity of this pattern fool you—it consistently fools selective trout all over the United States.',

      materials: [
        {
          type: 'Hook',
          name: 'Tiemco 101',
          detail: 'Size 18-24',
          url: 'https://bluequillangler.com/products/tiemco-101-25-pack-1?_pos=1&_sid=75a026558&_ss=r',
        },
        {
          type: 'Bead',
          name: 'Glass Bead',
          detail: 'Extra Small',
          url: 'https://bluequillangler.com/collections/fly-tying-beads/products/glass-beads-x-small-1',
        },
        {
          type: 'Thread',
          name: '8/0 Uni Thread',
          detail: 'Black',
          url: 'https://bluequillangler.com/collections/fly-tying-thread-floss/products/uni-8-0-thread-1',
        },
        {
          type: 'Thorax',
          name: 'Dubbing',
          detail: 'Black',
          url: 'https://bluequillangler.com/collections/fly-tying-dubbing/products/superfine-dubbing',
        },
            {
          type: 'Rib',
          name: 'Copper Ultra Wire',
          detail: 'Small',
          url: 'https://bluequillangler.com/collections/fly-tying-wire/products/utc-ultra-wire',
        }],

      publishedDate: '',

      order: 6,

      published: true
    }

  ];


  /* ==========================================================
     SETTINGS
     ========================================================== */

  var ROOT_SELECTOR =
    '[data-bqa-ftv-library]';

  var DESCRIPTION_LIMIT = 180;


  /* ==========================================================
     INITIALIZATION
     ========================================================== */

  function ready(callback) {
    if (
      document.readyState === 'loading'
    ) {
      document.addEventListener(
        'DOMContentLoaded',
        callback,
        { once: true }
      );
    } else {
      callback();
    }
  }


  ready(function () {
    document
      .querySelectorAll(ROOT_SELECTOR)
      .forEach(initLibrary);
  });


  document.addEventListener(
    'shopify:section:load',
    function (event) {
      var scope =
        event.target || document;

      scope
        .querySelectorAll(ROOT_SELECTOR)
        .forEach(initLibrary);
    }
  );


  /* ==========================================================
     INITIALIZE LIBRARY
     ========================================================== */

  function initLibrary(root) {
    if (
      !root ||
      root.dataset.bqaFtvReady === 'true'
    ) {
      return;
    }

    root.dataset.bqaFtvReady = 'true';


    var grid =
      root.querySelector(
        '[data-bqa-ftv-grid]'
      );

    var searchInput =
      root.querySelector(
        '[data-bqa-ftv-search]'
      );

    var categorySelect =
      root.querySelector(
        '[data-bqa-ftv-category]'
      );

    var topicSelect =
      root.querySelector(
        '[data-bqa-ftv-topic]'
      );

    var sortSelect =
      root.querySelector(
        '[data-bqa-ftv-sort]'
      );

    var count =
      root.querySelector(
        '[data-bqa-ftv-count]'
      );

    var clearButton =
      root.querySelector(
        '[data-bqa-ftv-clear]'
      );

    var emptyState =
      root.querySelector(
        '[data-bqa-ftv-empty]'
      );

    var setupNotice =
      root.querySelector(
        '[data-bqa-ftv-setup]'
      );

    var videoModal =
      root.querySelector(
        '[data-bqa-ftv-modal]'
      );

    var logoUrl =
      clean(
        root.getAttribute(
          'data-logo-url'
        )
      );


    if (
      !grid ||
      !videoModal
    ) {
      return;
    }


    var videos =
      VIDEOS
        .filter(function (video) {
          return (
            video &&
            video.published !== false
          );
        })
        .map(normalizeVideo);


    var state = {
      search: '',
      category: '',
      topic: '',
      sort: 'recommended'
    };


    populateSelect(
      categorySelect,
      uniqueValues(
        videos,
        'category'
      ),
      'All fly types'
    );


    populateSelect(
      topicSelect,
      uniqueTopics(videos),
      'All topics'
    );


    if (setupNotice) {
      setupNotice.hidden =
        !videos.some(
          function (video) {
            return !video.youtubeId;
          }
        );
    }


    render();


    /* ========================================================
       SEARCH
       ======================================================== */

    if (searchInput) {
      searchInput.addEventListener(
        'input',
        debounce(
          function () {
            state.search =
              clean(
                searchInput.value
              ).toLowerCase();

            render();
          },
          120
        )
      );
    }


    /* ========================================================
       CATEGORY FILTER
       ======================================================== */

    if (categorySelect) {
      categorySelect.addEventListener(
        'change',
        function () {
          state.category =
            categorySelect.value;

          render();
        }
      );
    }


    /* ========================================================
       TOPIC FILTER
       ======================================================== */

    if (topicSelect) {
      topicSelect.addEventListener(
        'change',
        function () {
          state.topic =
            topicSelect.value;

          render();
        }
      );
    }


    /* ========================================================
       SORT
       ======================================================== */

    if (sortSelect) {
      sortSelect.addEventListener(
        'change',
        function () {
          state.sort =
            sortSelect.value ||
            'recommended';

          render();
        }
      );
    }


    /* ========================================================
       CLEAR FILTERS
       ======================================================== */

    if (clearButton) {
      clearButton.addEventListener(
        'click',
        function () {
          state.search = '';
          state.category = '';
          state.topic = '';
          state.sort = 'recommended';

          if (searchInput) {
            searchInput.value = '';
          }

          if (categorySelect) {
            categorySelect.value = '';
          }

          if (topicSelect) {
            topicSelect.value = '';
          }

          if (sortSelect) {
            sortSelect.value =
              'recommended';
          }

          render();

          if (searchInput) {
            searchInput.focus();
          }
        }
      );
    }


    /* ========================================================
       CARD / MODAL CLICK HANDLING
       ======================================================== */

    root.addEventListener(
      'click',
      function (event) {

        var videoOpener =
          event.target.closest(
            '[data-bqa-ftv-open]'
          );

        var videoCloser =
          event.target.closest(
            '[data-bqa-ftv-close]'
          );

        var materialsOpener =
          event.target.closest(
            '[data-bqa-ftv-materials]'
          );

        var descriptionToggle =
          event.target.closest(
            '[data-bqa-ftv-description-toggle]'
          );


        /* MORE / LESS */

        if (
          descriptionToggle &&
          root.contains(
            descriptionToggle
          )
        ) {
          toggleDescription(
            descriptionToggle
          );

          return;
        }


        /* SHOP MATERIALS */

        if (
          materialsOpener &&
          root.contains(
            materialsOpener
          )
        ) {
          var materialsKey =
            materialsOpener.getAttribute(
              'data-video-key'
            );

          var materialsVideo =
            videos.find(
              function (item) {
                return (
                  item.key ===
                  materialsKey
                );
              }
            );

          if (
            materialsVideo &&
            materialsVideo.materials.length
          ) {
            openMaterialsModal(
              root,
              materialsVideo,
              materialsOpener
            );
          }

          return;
        }


        /* WATCH VIDEO */

        if (
          videoOpener &&
          root.contains(videoOpener) &&
          !videoOpener.disabled
        ) {
          var key =
            videoOpener.getAttribute(
              'data-video-key'
            );

          var video =
            videos.find(
              function (item) {
                return (
                  item.key === key
                );
              }
            );

          if (
            video &&
            video.youtubeId
          ) {
            openVideoModal(
              videoModal,
              video,
              videoOpener
            );
          }
        }


        /* CLOSE VIDEO */

        if (
          videoCloser &&
          root.contains(videoCloser)
        ) {
          closeVideoModal(
            videoModal
          );
        }
      }
    );


    /* ========================================================
       VIDEO MODAL KEYBOARD
       ======================================================== */

    videoModal.addEventListener(
      'keydown',
      function (event) {
        if (
          event.key === 'Escape'
        ) {
          closeVideoModal(
            videoModal
          );
        }

        if (
          event.key === 'Tab'
        ) {
          trapFocus(
            videoModal,
            event
          );
        }
      }
    );


    /* ========================================================
       RENDER
       ======================================================== */

    function render() {
      var visible =
        videos.filter(
          function (video) {

            var searchMatch =
              !state.search ||
              video.searchText.indexOf(
                state.search
              ) !== -1;


            var categoryMatch =
              !state.category ||
              video.category ===
                state.category;


            var topicMatch =
              !state.topic ||
              video.topics.indexOf(
                state.topic
              ) !== -1;


            return (
              searchMatch &&
              categoryMatch &&
              topicMatch
            );
          }
        );


      visible =
        sortVideos(
          visible,
          state.sort
        );


      var fragment =
        document.createDocumentFragment();


      visible.forEach(
        function (video) {
          fragment.appendChild(
            buildCard(
              video,
              logoUrl
            )
          );
        }
      );


      grid.replaceChildren(
        fragment
      );


      if (count) {
        count.textContent =
          visible.length ===
          videos.length
            ? videos.length +
              (
                videos.length === 1
                  ? ' video'
                  : ' videos'
              )
            : 'Showing ' +
              visible.length +
              ' of ' +
              videos.length +
              ' videos';
      }


      if (emptyState) {
        emptyState.hidden =
          visible.length !== 0;
      }


      if (clearButton) {
        clearButton.hidden =
          !(
            state.search ||
            state.category ||
            state.topic ||
            state.sort !==
              'recommended'
          );
      }
    }
  }


  /* ==========================================================
     NORMALIZE VIDEO DATA
     ========================================================== */

  function normalizeVideo(
    video,
    index
  ) {

    var title =
      clean(video.title) ||
      'Untitled Fly Tying Video';


    var topics =
      Array.isArray(video.topics)
        ? video.topics
            .map(clean)
            .filter(Boolean)
        : [];


    var materials =
      Array.isArray(video.materials)
        ? video.materials
            .map(
              function (material) {
                return {
                  type:
                    clean(
                      material.type
                    ),

                  name:
                    clean(
                      material.name
                    ),

                  detail:
                    clean(
                      material.detail
                    ),

                  url:
                    safeMaterialUrl(
                      material.url
                    )
                };
              }
            )
            .filter(
              function (material) {
                return material.name;
              }
            )
        : [];


    var materialsSearch =
      materials
        .map(
          function (material) {
            return [
              material.type,
              material.name,
              material.detail
            ].join(' ');
          }
        )
        .join(' ');


    return {

      key:
        (
          clean(video.id) ||
          slugify(title) ||
          'video'
        ) +
        '-' +
        index,


      title:
        title,


      youtubeId:
        extractYouTubeId(
          video.youtube
        ),


      thumbnailUrl:
        clean(
          video.thumbnailUrl
        ),


      duration:
        clean(
          video.duration
        ),


      category:
        clean(video.category) ||
        'Fly Tying',


      topics:
        topics,


      materials:
        materials,


      instructor:
        clean(video.instructor) ||
        'Blue Quill Angler',


      description:
        clean(video.description) ||
        'Watch this Blue Quill Angler fly tying video.',


      publishedDate:
        Date.parse(
          clean(
            video.publishedDate
          )
        ) || 0,


      order:
        Number.isFinite(
          Number(video.order)
        )
          ? Number(video.order)
          : 9999,


      searchText:
        [
          title,
          video.description,
          video.category,
          topics.join(' '),
          video.instructor,
          materialsSearch
        ]
          .join(' ')
          .toLowerCase()
    };
  }


  /* ==========================================================
     BUILD VIDEO CARD
     ========================================================== */

  function buildCard(
    video,
    logoUrl
  ) {

    var card =
      el(
        'article',
        'bqa-ftv-card'
      );


    var media =
      el(
        'button',
        'bqa-ftv-card__media'
      );


    var body =
      el(
        'div',
        'bqa-ftv-card__body'
      );


    var hasVideo =
      Boolean(
        video.youtubeId
      );


    var thumbnail =
      video.thumbnailUrl ||
      (
        hasVideo
          ? 'https://i.ytimg.com/vi/' +
            encodeURIComponent(
              video.youtubeId
            ) +
            '/hqdefault.jpg'
          : ''
      );


    /* THUMBNAIL */

    media.type = 'button';

    media.disabled =
      !hasVideo;

    media.setAttribute(
      'data-bqa-ftv-open',
      ''
    );

    media.setAttribute(
      'data-video-key',
      video.key
    );

    media.setAttribute(
      'aria-label',
      hasVideo
        ? 'Watch ' +
          video.title
        : video.title +
          ' is not configured yet'
    );


    var placeholder =
      el(
        'span',
        'bqa-ftv-card__placeholder'
      );


    placeholder.append(
      el(
        'span',
        'bqa-ftv-card__placeholder-kicker',
        'Blue Quill Fly Tying'
      ),

      el(
        'span',
        'bqa-ftv-card__placeholder-title',
        video.title
      )
    );


    media.appendChild(
      placeholder
    );


    if (thumbnail) {

      var image =
        el(
          'img',
          'bqa-ftv-card__image'
        );


      image.src =
        thumbnail;


      image.alt =
        video.title +
        ' fly tying video thumbnail';


      image.loading =
        'lazy';


      image.width =
        1280;


      image.height =
        720;


      image.addEventListener(
        'error',
        function () {
          image.hidden = true;
        },
        { once: true }
      );


      media.appendChild(
        image
      );
    }


    /* DURATION */

    if (video.duration) {
      media.appendChild(
        el(
          'span',
          'bqa-ftv-card__duration',
          video.duration
        )
      );
    }


    /* CATEGORY */

    var tags =
      el(
        'div',
        'bqa-ftv-card__tags'
      );


    tags.appendChild(
      el(
        'span',
        'bqa-ftv-card__tag',
        video.category
      )
    );


    /* TITLE */

    var title =
      el(
        'h2',
        'bqa-ftv-card__title',
        video.title
      );


    /* DESCRIPTION */

    var descriptionBlock =
      buildDescription(
        video.description
      );


    /* INSTRUCTOR */

    var instructor =
      el(
        'div',
        'bqa-ftv-card__instructor'
      );


    if (logoUrl) {

      var logo =
        el(
          'img',
          'bqa-ftv-card__logo'
        );


      logo.src =
        logoUrl;


      logo.alt =
        'Blue Quill Angler yellow Q logo';


      logo.loading =
        'lazy';


      logo.width =
        96;


      logo.height =
        96;


      instructor.appendChild(
        logo
      );
    }


    var instructorText =
      el(
        'span',
        'bqa-ftv-card__instructor-text'
      );


    instructorText.append(
      el(
        'span',
        '',
        'From'
      ),

      el(
        'strong',
        '',
        video.instructor
      )
    );


    instructor.appendChild(
      instructorText
    );


    /* ACTION BUTTON AREA */

    var actions =
      el(
        'div',
        'bqa-ftv-card__actions bqa-ftv-card__actions--single'
      );


    /* WATCH VIDEO */

    var watchButton =
      el(
        'button',
        'bqa-ftv-card__button bqa-ftv-card__button--primary'
      );


    watchButton.type =
      'button';


    watchButton.disabled =
      !hasVideo;


    watchButton.setAttribute(
      'data-bqa-ftv-open',
      ''
    );


    watchButton.setAttribute(
      'data-video-key',
      video.key
    );


    watchButton.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="M8 5v14l11-7z"></path>' +
      '</svg>' +
      '<span>' +
      (
        hasVideo
          ? 'Watch Video'
          : 'Add Video ID'
      ) +
      '</span>';


    actions.appendChild(
      watchButton
    );


    /* SHOP MATERIALS */

    if (
      video.materials &&
      video.materials.length
    ) {

      var materialsButton =
        el(
          'button',
          'bqa-ftv-card__button bqa-ftv-card__button--materials'
        );


      materialsButton.type =
        'button';


      materialsButton.setAttribute(
        'data-bqa-ftv-materials',
        ''
      );


      materialsButton.setAttribute(
        'data-video-key',
        video.key
      );


      materialsButton.innerHTML =
        '<span>Shop Materials</span>';


      actions.appendChild(
        materialsButton
      );


      actions.classList.remove(
        'bqa-ftv-card__actions--single'
      );


      actions.classList.add(
        'bqa-ftv-card__actions--double'
      );
    }


    body.append(
      tags,
      title,
      descriptionBlock,
      instructor,
      actions
    );


    card.append(
      media,
      body
    );


    return card;
  }


  /* ==========================================================
     DESCRIPTION — MORE / LESS
     ========================================================== */

  function buildDescription(
    description
  ) {

    var wrapper =
      el(
        'div',
        'bqa-ftv-card__description-wrap'
      );


    var text =
      el(
        'p',
        'bqa-ftv-card__description'
      );


    var full =
      clean(description);


    if (
      full.length <=
      DESCRIPTION_LIMIT
    ) {

      text.textContent =
        full;


      wrapper.appendChild(
        text
      );


      return wrapper;
    }


    var shortText =
      truncateAtWord(
        full,
        DESCRIPTION_LIMIT
      );


    text.textContent =
      shortText + '…';


    text.setAttribute(
      'data-bqa-ftv-description-text',
      ''
    );


    text.setAttribute(
      'data-short-text',
      shortText + '…'
    );


    text.setAttribute(
      'data-full-text',
      full
    );


    var toggle =
      el(
        'button',
        'bqa-ftv-card__more',
        'More'
      );


    toggle.type =
      'button';


    toggle.setAttribute(
      'data-bqa-ftv-description-toggle',
      ''
    );


    toggle.setAttribute(
      'aria-expanded',
      'false'
    );


    wrapper.append(
      text,
      toggle
    );


    return wrapper;
  }


  function toggleDescription(
    button
  ) {

    var wrapper =
      button.closest(
        '.bqa-ftv-card__description-wrap'
      );


    if (!wrapper) {
      return;
    }


    var text =
      wrapper.querySelector(
        '[data-bqa-ftv-description-text]'
      );


    if (!text) {
      return;
    }


    var expanded =
      button.getAttribute(
        'aria-expanded'
      ) === 'true';


    if (expanded) {

      text.textContent =
        text.getAttribute(
          'data-short-text'
        );


      button.textContent =
        'More';


      button.setAttribute(
        'aria-expanded',
        'false'
      );

    } else {

      text.textContent =
        text.getAttribute(
          'data-full-text'
        );


      button.textContent =
        'Less';


      button.setAttribute(
        'aria-expanded',
        'true'
      );
    }
  }


  function truncateAtWord(
    text,
    limit
  ) {

    if (
      text.length <= limit
    ) {
      return text;
    }


    var shortened =
      text.slice(
        0,
        limit + 1
      );


    var lastSpace =
      shortened.lastIndexOf(
        ' '
      );


    if (
      lastSpace > 0
    ) {
      shortened =
        shortened.slice(
          0,
          lastSpace
        );
    }


    return shortened.trim();
  }


  /* ==========================================================
     VIDEO MODAL
     ========================================================== */

  function openVideoModal(
    modal,
    video,
    trigger
  ) {

    var player =
      modal.querySelector(
        '[data-bqa-ftv-player]'
      );


    var title =
      modal.querySelector(
        '[data-bqa-ftv-modal-title]'
      );


    var description =
      modal.querySelector(
        '[data-bqa-ftv-modal-description]'
      );


    var meta =
      modal.querySelector(
        '[data-bqa-ftv-modal-meta]'
      );


    var closeButton =
      modal.querySelector(
        '[data-bqa-ftv-close-button]'
      );


    if (
      !player ||
      !video.youtubeId
    ) {
      return;
    }


    var iframe =
      document.createElement(
        'iframe'
      );


    /*
      No autoplay.

      The customer deliberately starts
      playback in the YouTube player.
    */

    iframe.src =
      'https://www.youtube-nocookie.com/embed/' +
      encodeURIComponent(
        video.youtubeId
      ) +
      '?rel=0&modestbranding=1';


    iframe.title =
      video.title +
      ' fly tying video';


    iframe.allow =
      'accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';


    iframe.allowFullscreen =
      true;


    iframe.referrerPolicy =
      'strict-origin-when-cross-origin';


    player.replaceChildren(
      iframe
    );


    meta.replaceChildren();


    meta.appendChild(
      el(
        'span',
        'bqa-ftv-card__tag',
        video.category
      )
    );


    if (video.duration) {
      meta.appendChild(
        el(
          'span',
          'bqa-ftv-card__tag',
          video.duration
        )
      );
    }


    title.textContent =
      video.title;


    description.textContent =
      video.description;


    modal._lastTrigger =
      trigger;


    modal.hidden =
      false;


    document.documentElement
      .classList.add(
        'bqa-ftv-modal-open'
      );


    requestAnimationFrame(
      function () {
        modal.classList.add(
          'is-open'
        );
      }
    );


    if (closeButton) {
      closeButton.focus();
    }
  }


  function closeVideoModal(
    modal
  ) {

    if (
      !modal ||
      modal.hidden
    ) {
      return;
    }


    var player =
      modal.querySelector(
        '[data-bqa-ftv-player]'
      );


    if (player) {
      player.replaceChildren();
    }


    modal.classList.remove(
      'is-open'
    );


    document.documentElement
      .classList.remove(
        'bqa-ftv-modal-open'
      );


    window.setTimeout(
      function () {

        modal.hidden =
          true;


        if (
          modal._lastTrigger
        ) {
          modal._lastTrigger.focus();
        }

      },
      180
    );
  }


  /* ==========================================================
     MATERIALS MODAL
     ========================================================== */

  function openMaterialsModal(
    root,
    video,
    trigger
  ) {

    var existing =
      root.querySelector(
        '[data-bqa-ftv-materials-modal]'
      );


    if (existing) {
      existing.remove();
    }


    var modal =
      el(
        'div',
        'bqa-ftv-materials-modal'
      );


    modal.setAttribute(
      'data-bqa-ftv-materials-modal',
      ''
    );


    var backdrop =
      el(
        'button',
        'bqa-ftv-materials-modal__backdrop'
      );


    backdrop.type =
      'button';


    backdrop.setAttribute(
      'aria-label',
      'Close materials'
    );


    var dialog =
      el(
        'div',
        'bqa-ftv-materials-modal__dialog'
      );


    dialog.setAttribute(
      'role',
      'dialog'
    );


    dialog.setAttribute(
      'aria-modal',
      'true'
    );


    dialog.setAttribute(
      'aria-label',
      'Materials for ' +
      video.title
    );


    /* HEADER */

    var header =
      el(
        'div',
        'bqa-ftv-materials-modal__header'
      );


    var heading =
      el(
        'div',
        'bqa-ftv-materials-modal__heading'
      );


    heading.append(
      el(
        'span',
        'bqa-ftv-materials-modal__eyebrow',
        'Materials Used'
      ),

      el(
        'h2',
        'bqa-ftv-materials-modal__title',
        video.title
      )
    );


    var closeButton =
      el(
        'button',
        'bqa-ftv-materials-modal__close',
        '×'
      );


    closeButton.type =
      'button';


    closeButton.setAttribute(
      'aria-label',
      'Close materials'
    );


    header.append(
      heading,
      closeButton
    );


    /* INTRO */

    var intro =
      el(
        'p',
        'bqa-ftv-materials-modal__intro',
        'Here are the primary materials used to tie this pattern.'
      );


    /* MATERIAL LIST */

    var list =
      el(
        'div',
        'bqa-ftv-materials-list'
      );


    video.materials.forEach(
      function (material) {

        var row =
          el(
            'div',
            'bqa-ftv-materials-list__item'
          );


        var info =
          el(
            'div',
            'bqa-ftv-materials-list__info'
          );


        if (material.type) {
          info.appendChild(
            el(
              'span',
              'bqa-ftv-materials-list__type',
              material.type
            )
          );
        }


        info.appendChild(
          el(
            'strong',
            'bqa-ftv-materials-list__name',
            material.name
          )
        );


        if (material.detail) {
          info.appendChild(
            el(
              'span',
              'bqa-ftv-materials-list__detail',
              material.detail
            )
          );
        }


        row.appendChild(
          info
        );


        /* SHOP LINK */

        if (material.url) {

          var shopLink =
            el(
              'a',
              'bqa-ftv-materials-list__shop',
              'Shop'
            );


          shopLink.href =
            material.url;


          row.appendChild(
            shopLink
          );

        } else {

          row.appendChild(
            el(
              'span',
              'bqa-ftv-materials-list__coming',
              'Product link coming soon'
            )
          );
        }


        list.appendChild(
          row
        );
      }
    );


    dialog.append(
      header,
      intro,
      list
    );


    modal.append(
      backdrop,
      dialog
    );


    root.appendChild(
      modal
    );


    modal._lastTrigger =
      trigger;


    document.documentElement
      .classList.add(
        'bqa-ftv-modal-open'
      );


    requestAnimationFrame(
      function () {
        modal.classList.add(
          'is-open'
        );
      }
    );


    /* CLOSE FUNCTION */

    function closeMaterials() {

      modal.classList.remove(
        'is-open'
      );


      document.documentElement
        .classList.remove(
          'bqa-ftv-modal-open'
        );


      window.setTimeout(
        function () {

          modal.remove();


          if (
            modal._lastTrigger
          ) {
            modal._lastTrigger.focus();
          }

        },
        180
      );
    }


    backdrop.addEventListener(
      'click',
      closeMaterials
    );


    closeButton.addEventListener(
      'click',
      closeMaterials
    );


    modal.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key === 'Escape'
        ) {
          closeMaterials();
        }


        if (
          event.key === 'Tab'
        ) {
          trapFocus(
            modal,
            event
          );
        }
      }
    );


    closeButton.focus();
  }


  /* ==========================================================
     FOCUS TRAP
     ========================================================== */

  function trapFocus(
    container,
    event
  ) {

    var focusable =
      Array.prototype.slice
        .call(
          container.querySelectorAll(
            'a[href], ' +
            'button:not([disabled]), ' +
            'input:not([disabled]), ' +
            'select:not([disabled]), ' +
            '[tabindex]:not([tabindex="-1"])'
          )
        )
        .filter(
          function (item) {
            return (
              !item.hidden &&
              item.offsetParent !== null
            );
          }
        );


    if (!focusable.length) {
      return;
    }


    var first =
      focusable[0];


    var last =
      focusable[
        focusable.length - 1
      ];


    if (
      event.shiftKey &&
      document.activeElement === first
    ) {

      event.preventDefault();

      last.focus();

    } else if (
      !event.shiftKey &&
      document.activeElement === last
    ) {

      event.preventDefault();

      first.focus();
    }
  }


  /* ==========================================================
     SORT VIDEOS
     ========================================================== */

  function sortVideos(
    videos,
    mode
  ) {

    return videos
      .slice()
      .sort(
        function (a, b) {

          if (
            mode === 'title'
          ) {
            return (
              a.title.localeCompare(
                b.title
              )
            );
          }


          if (
            mode === 'newest'
          ) {
            return (
              b.publishedDate -
                a.publishedDate ||
              a.order -
                b.order
            );
          }


          return (
            a.order -
              b.order ||
            a.title.localeCompare(
              b.title
            )
          );
        }
      );
  }


  /* ==========================================================
     POPULATE SELECT
     ========================================================== */

  function populateSelect(
    select,
    values,
    allLabel
  ) {

    if (!select) {
      return;
    }


    select.replaceChildren();


    var all =
      document.createElement(
        'option'
      );


    all.value = '';

    all.textContent =
      allLabel;


    select.appendChild(
      all
    );


    values.forEach(
      function (value) {

        var option =
          document.createElement(
            'option'
          );


        option.value =
          value;


        option.textContent =
          value;


        select.appendChild(
          option
        );
      }
    );
  }


  /* ==========================================================
     UNIQUE CATEGORIES
     ========================================================== */

  function uniqueValues(
    videos,
    property
  ) {

    return Array.from(
      new Set(
        videos
          .map(
            function (video) {
              return video[property];
            }
          )
          .filter(Boolean)
      )
    )
      .sort(
        function (a, b) {
          return (
            a.localeCompare(b)
          );
        }
      );
  }


  /* ==========================================================
     UNIQUE TOPICS
     ========================================================== */

  function uniqueTopics(
    videos
  ) {

    var values = [];


    videos.forEach(
      function (video) {

        video.topics.forEach(
          function (topic) {

            if (
              values.indexOf(
                topic
              ) === -1
            ) {
              values.push(
                topic
              );
            }
          }
        );
      }
    );


    return values.sort(
      function (a, b) {
        return (
          a.localeCompare(b)
        );
      }
    );
  }


  /* ==========================================================
     YOUTUBE ID PARSER
     ========================================================== */

  function extractYouTubeId(
    value
  ) {

    var candidate =
      clean(value);


    if (
      !candidate ||
      /PASTE_ID_HERE|REPLACE|YOUR_VIDEO/i.test(
        candidate
      )
    ) {
      return '';
    }


    if (
      /^[A-Za-z0-9_-]{11}$/.test(
        candidate
      )
    ) {
      return candidate;
    }


    var match =
      candidate.match(
        /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/))([A-Za-z0-9_-]{11})/
      );


    if (match) {
      return match[1];
    }


    try {

      var url =
        new URL(
          candidate,
          window.location.origin
        );


      var id =
        url.searchParams.get(
          'v'
        ) || '';


      return (
        /^[A-Za-z0-9_-]{11}$/.test(
          id
        )
          ? id
          : ''
      );

    } catch (error) {

      return '';
    }
  }


  /* ==========================================================
     SAFE PRODUCT URL
     ========================================================== */

  function safeMaterialUrl(
    value
  ) {

    var link =
      clean(value);


    if (!link) {
      return '';
    }


    /*
      Shopify relative links such as:

      /products/product-name
      /collections/materials
    */

    if (
      link.charAt(0) === '/' ||
      link.charAt(0) === '#'
    ) {
      return link;
    }


    /*
      Full https/http URL
    */

    try {

      var url =
        new URL(
          link,
          window.location.origin
        );


      return (
        /^(https?:)$/.test(
          url.protocol
        )
          ? url.href
          : ''
      );

    } catch (error) {

      return '';
    }
  }


  /* ==========================================================
     CREATE ELEMENT
     ========================================================== */

  function el(
    tag,
    className,
    text
  ) {

    var node =
      document.createElement(
        tag
      );


    if (className) {
      node.className =
        className;
    }


    if (
      text !== undefined
    ) {
      node.textContent =
        String(text);
    }


    return node;
  }


  /* ==========================================================
     CLEAN STRING
     ========================================================== */

  function clean(value) {

    return (
      value === null ||
      value === undefined
    )
      ? ''
      : String(value).trim();
  }


  /* ==========================================================
     SLUG
     ========================================================== */

  function slugify(
    value
  ) {

    return clean(value)
      .toLowerCase()
      .replace(
        /[^a-z0-9]+/g,
        '-'
      )
      .replace(
        /^-+|-+$/g,
        ''
      );
  }


  /* ==========================================================
     DEBOUNCE
     ========================================================== */

  function debounce(
    callback,
    delay
  ) {

    var timer;


    return function () {

      var context =
        this;


      var args =
        arguments;


      clearTimeout(
        timer
      );


      timer =
        setTimeout(
          function () {
            callback.apply(
              context,
              args
            );
          },
          delay
        );
    };
  }

}());